
import styled, { css } from 'styled-components';

const LoadModelButtonWrapper = () => css`

    display: ${({ show }) => (show ? 'flex' : 'none')};

   ${({ theme }) => (
        theme == 'vivaTheme' &&
        `
        bottom: 100px;
        height: 40px;
        z-index: 1112;
        position: absolute;
        width: 100%;
        max-width: 220px;
        
        @media only screen and (max-height: 500px) {
        max-height: 35px;
        max-width: 190px;
        bottom: 50px;
        };

        @media (max-width: 600px) {
          width: 88%;
          max-width: 220px;
          min-width: 137px;
        };

        @media (min-width: 1336px) {
          width: 100%;
        };

        `
    ) ||
        (theme != 'vivaTheme' &&
            `
        position: absolute;
        bottom: 50%;
        left: 50%;
        z-index: 1112;
        width: 110px;
        height: 40px;
        `)

    }

`;


export default styled.div([LoadModelButtonWrapper]);